import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';

import { SubSink } from 'subsink';

import { UserService } from '@authentication/services/user.service';
import { required } from '@shared/decorators/required.decorator';

@Directive({
  selector: '[appIfHasRoles]',
})
export class IfHasRolesDirective implements OnInit, OnDestroy {
  @Input() @required appIfHasRoles: string[] = [];
  private subs = new SubSink();

  constructor(
    private userService: UserService,
    private elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    if (this.appIfHasRoles.length) {
      this.subs.sink = this.userService
        .hasAnyRole(this.appIfHasRoles)
        .subscribe((res) => {
          if (!res) {
            this.elementRef.nativeElement.remove();
          }
        });
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
